/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reference: NonNullable<unknown> }} Error_ReferenceInputs */

const en_gb2_error_reference = /** @type {(inputs: Error_ReferenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error reference ${i?.reference}`)
};

const fr_error_reference = /** @type {(inputs: Error_ReferenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Référence de l'erreur ${i?.reference}`)
};

/**
* | output |
* | --- |
* | "Error reference {reference}" |
*
* @param {Error_ReferenceInputs} inputs
* @param {{ locale?: "en-GB" | "fr" }} options
* @returns {LocalizedString}
*/
export const error_reference = /** @type {((inputs: Error_ReferenceInputs, options?: { locale?: "en-GB" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_ReferenceInputs, { locale?: "en-GB" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_reference(inputs)
	return en_gb2_error_reference(inputs)
});